<template>
    <div id="zipcode">
        <div class="panel-zipcode">
            <h2 class="page-header">Je bent er bijna!</h2>
            <div class="panel-text-container">
                <p>Hoe wil je dat het coachgesprek plaatsvindt?</p>
            </div>

                <div class="radio-container">
                    <div class="radio-wrapper"><label><input type="radio" v-model="answer.toggleLive" value="online"><span class="tick">Online</span></label></div>
                    <div class="radio-wrapper"><label><input type="radio" v-model="answer.toggleLive" value="live"><span class="tick">Live</span></label></div>
                    <div class="radio-wrapper"><label><input type="radio" v-model="answer.toggleLive" value="both"><span class="tick">Combinatie van beide</span></label></div>
                </div>
                <p>&nbsp;</p>
                <div class="" v-show="showZipcode">
                    <p>Wat is je postcode?</p>
                    <input type="text" v-model="answer.zipcode" placeholder="1234 AB" @keydown.enter.prevent>
<!--                    <div class="alert alert-danger" v-if="invalid.regex && answer.zipcode && answer.zipcode.length >= 7"><span>Ongeldig formaat</span></div>-->

                    <p>&nbsp;</p>
                    <div class="panel-text-container">
                        <p>Sleep het bolletje naar de gewenste maximale afstand.</p>
                    </div>

                    <div class="distance-wrapper">
                        <div class="distance-label">Vul je maximale afstand in:</div>
                        <div class="distance-value blue">{{ answer.distance }} KM</div>
                    </div>
                    <input name="distance" type="range" min="20" max="50" step="5" v-model="answer.distance">
                </div>
                <div v-if="$parent.loading" class="loading-container">
                    <div class="loading-text">We zijn gegevens aan het ophalen.<br>Een ogenblik geduld...</div>
                </div>
                <div class="buttons-container">
                    <previous-button />
                    <button @click="submitAnswer" :disabled="!allValid" class="next">Toon mijn matches</button>
                </div>
        </div>
    </div>
</template>

<script>
    import NextButton from "../partials/NextButton";
    import PreviousButton from "../partials/PreviousButton";

    export default {
        name: 'Zipcode',
        components: {
            PreviousButton,
            NextButton
        },
        props: {
            isValid: {
                type: Function
            },
            answer: {
                type: Object
            },
            invalid: {
                type: Object
            },
            isAnswered: {
                type: Object
            },
            submitAnswer: {
                type: Function
            }
        },
        computed: {
            showZipcode() {
              let showZipcode = this.answer.toggleLive && this.answer.toggleLive !== 'online'

              if (!showZipcode) {
                  this.answer.zipcode = null;
              }

              return showZipcode
            },
            allValid()
            {
                let validZipcode = true;

                if (this.showZipcode) {
                   validZipcode = this.isValid('zipcode')
                }

                return this.answer.toggleLive && validZipcode
            }
        },
        data() {
            return {
                rules: {
                  toggleLive: {
                     required: true
                  },
                  zipcode: {
                     regex: '^[1-9][0-9]{3} ?[a-zA-Z]{2}$'
                  }
                }
            }
        },
        created() {
            this.$emit('setRules', this.rules)
        }
    }

</script>
